// import { mockOspedali } from "./mock";

export const preparaListaStrutture = (data) => {
  let listaStrutture = null;
  if (data && data !== undefined)
    listaStrutture = data.map((struttura) => ({
      id: struttura.codice_struttura.toString(),
      value: struttura.desc_struttura,
      disabled: !struttura.struttura_abilitata,
    }));
  listaStrutture = listaStrutture.sort((a, b) => {
    let nameA = a.value.toUpperCase();
    let nameB = b.value.toUpperCase();
    if (nameA < nameB) return -1;
    else if (nameA > nameB) return 1;
    else return 0;
  });
  return listaStrutture;
};

export const preparaListaOspedali = (data) => {
// export const preparaListaOspedali = () => {
  // const data = mockOspedali; // TODO togliere quando servizio è a posto
  let listaOspedali = null;
  if (data && data !== undefined)
    listaOspedali = data.map((ospedale) => ({
      id: ospedale.codice_ente.toString(),
      value: ospedale.desc_ente,
      disabled: !ospedale.ente_abilitato,
      strutture: preparaListaStrutture(ospedale.strutture),
    }));
  listaOspedali = listaOspedali.sort((a, b) => {
    let nameA = a.value.toUpperCase();
    let nameB = b.value.toUpperCase();
    if (nameA < nameB) return -1;
    else if (nameA > nameB) return 1;
    else return 0;
  });
  return listaOspedali;
};
